<script type="ts">
	import type { IThemedToken } from "shiki";
	import Line from "./Line.svelte";

	export let lines: IThemedToken[][];
</script>
<code>{#each lines as line}<Line tokens={line} />{/each}</code>